module.exports = __webpack_public_path__ + "static/media/uber.7b57f5ac.svg";